import React, {useContext, useEffect, useState} from "react";

/* Styles */
import {Filters} from "./send-alignment-tab.styles";

/* Components */
import TableToSendData from "../../../../components/table-to-send-data/table-to-send-data.component";
import PopUp from "../../../../components/popup/popup.component";
import RenderPage from "../../../../components/render-page/render-page.component";

/* Material UI */
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

/* Context */
import {authContext} from "../../../../contexts/AuthContext";

/* Api*/
import {findAllActiveUserAlignments, getMatchMonthAlignments, sendMonthlyAlignment} from "../../../../api/ApiAlignment";
import {getAllUsersInCompany} from "../../../../api/ApiUser";

/* Utils */
import {getColor} from "../../../../utils/genericFunctions";
import {yearsUntilNow} from "../../../../utils/initialData";

/* Permissions */
import permissions, {getSubmodulePermission} from "../../../../utils/permission";
import {findIfSubmoduleIsActive} from "../../../../api/ApiPemissions";

const today = new Date();

const optionsMonths = [{name: "Janeiro", monthNumber: "01"}, {name: "Fevereiro", monthNumber: "02"}, {name: "Março", monthNumber: "03"}, {name: "Abril", monthNumber: "04"}, {name: "Maio", monthNumber: "05"}, {name: "Junho", monthNumber: "06"}, {name: "Julho", monthNumber: "07"}, {name: "Agosto", monthNumber: "08"}, {name: "Setembro", monthNumber: "09"}, {name: "Outubro", monthNumber: "10"}, {name: "Novembro", monthNumber: "11"}, {name: "Dezembro", monthNumber: "12"}];
const optionsYear = yearsUntilNow();

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 150,
    },
    userFormControl: {
        backgroundColor: "#fff3e0",
        margin: theme.spacing(1),
        minWidth: 180,
    },
    formControlYear: {
        margin: theme.spacing(1),
        minWidth: 90,
        width: 100,
        borderRadius: 10,
    },
}));

export default function SendAlignment() {
    const classes = useStyles();
    const {auth} = useContext(authContext);
    const [rows, setRows] = useState([]);

    const [year, setYear] = React.useState(today.getFullYear());
    const [month, setMonth] = React.useState(optionsMonths[(today.getMonth())]);

    const [optionsUsers, setOptionsUsers] = useState([]);
    const [user, setUser] = useState({
        userId: auth.data.user.userId,
        name: auth.data.user.name,
        companyId: auth.data.user.companyId
    });
    const [fillOthers, setFillOthers] = useState(false);

    const [submodules, setSubmodules] = useState({
        alignment: []
    });

    const [popUp, setPopUp] = React.useState({
        popUp: false,
        popUpTitle: "",
        popUpText: "",
        success: 1,
    });

    const [fetchOpen, setFetchOpen] = useState(true);

    let textData = {
        tableTitle: fillOthers ? `Alinhamentos de ${user ? user.name : ""}` : "Alinhamentos",
        textButton: "Salvar"
    };

    useEffect(() => {
        const callApiFindUserAlignments = async (user, globalCompany) => {
            const response = await findAllActiveUserAlignments(auth, globalCompany, user);
            const body = await response.json();

            if (response.status !== 200) throw Error(body.message);

            return body.payload
        };

        const callApiMatchDateAlignments = async (data, globalCompany) => {
            const response = await getMatchMonthAlignments(auth, data, globalCompany);
            const body = await response.json();

            if (response.status !== 200) throw Error(body.message);

            return body.payload
        };

        const callApiUsersInCompany = async (globalCompany) => {
            const response = await getAllUsersInCompany(auth, globalCompany);
            const body = await response.json();

            if (response.status !== 200) throw Error(body.message);

            return body.payload;
        };

        const callFindIfSubmoduleIsActive = async (permissionRole, permissionModule) => {
            const response = await findIfSubmoduleIsActive(auth, permissionRole, permissionModule);
            const body = await response.json();

            return body.payload
        };

        let isToday = false;
        if(!fillOthers) {
            isToday = true;
        }
        let date = new Date().toISOString();
        date = date.split("-");

        if(!user || !month || !year){
            setPopUp({
                popUp: true,
                popUpTitle: "Erro",
                popUpText: "Por favor, insira os dados no filtro.",
                success: 1,
            })
            return;
        }

        let data = {
            user: user.userId,
            month: isToday ? date[1] : month.monthNumber,
            year: isToday ? date[0] : year
        }

        callApiUsersInCompany(auth.data.user.companyId)
            .then(findAllUsersInRes => {
                findAllUsersInRes = findAllUsersInRes.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))

                setOptionsUsers(findAllUsersInRes);
            })
            .catch(err => console.log(err));
        callFindIfSubmoduleIsActive(auth.data.user.permissionRoleId, permissions.IPA_SEND_ALIGNMENT)
            .then(resSend => {
                setSubmodules({alignment: resSend});
            })
            .catch(err => console.log(err));

        callApiFindUserAlignments(user, auth.data.user.companyId )
            .then(alignmentsRes => {
                callApiMatchDateAlignments(data, auth.data.user.companyId)
                    .then(monthAlignmentRes => {
                        let tempRows = [];
                        let tempValue;

                        for(let i=0; i < alignmentsRes.length; i++) {
                            tempValue = monthAlignmentRes.filter(key => key.alignmentId === alignmentsRes[i].alignmentId);

                            if(tempValue.length === 0) {
                                tempRows[i] = {userId: alignmentsRes[i].userId, alignmentId: alignmentsRes[i].alignmentId, name: alignmentsRes[i].name, value: '', color: getColor(null)}
                            } else {

                                tempRows[i] = {userId: alignmentsRes[i].userId, alignmentId: alignmentsRes[i].alignmentId,name: alignmentsRes[i].name, value: tempValue[0].grade, color: getColor(tempValue[0].grade)}
                            }
                        }

                        setRows(tempRows);
                        setFetchOpen(false);
                    })
                    .catch(err => console.log(err));
            })
            .catch(err => console.log(err));



    }, [auth, month, year, user]);

    function handleChange(e, row, index) {
        let newArr = [...rows]; // copying the old datas array
        let color;

        color = getColor(e.target.value);

        let allow;

        if (e.target.value.match(/-/gi) && (e.target.value.length === 1))
            allow = true;
        else if (e.target.value.match(/-/gi) && (['-1', '-2', '-3'].indexOf(e.target.value) > -1))
            allow = true;
        else if (e.target.value.length === 1 && (['1', '2', '3'].indexOf(e.target.value) > -1))
            allow = true;
        else
            allow = false;

        if (allow) {
            newArr[index].value = e.target.value;
            newArr[index].color = color;
        } else {
            newArr[index].value = '';
            newArr[index].color = '';
        }

        setRows(newArr);

    }
    const handleSubmit = async event => {
        event.preventDefault();
        setFetchOpen(true);
        if(!user || !month || !year){
            setPopUp({
                popUp: true,
                popUpTitle: "Erro",
                popUpText: "Por favor, insira os dados no filtro.",
                success: 1,
            })
            return;
        }

        for(let i=0; i < rows.length ; i++) {
            if(rows[i].value === '') {
                setPopUp({
                    popUp: true,
                    popUpTitle: "Erro",
                    popUpText: "Por favor, preencha todos os campos.",
                    success: 1,
                })
                return;
            }
        }

        let res = [];
        let isToday = false;
        if(!fillOthers) {
            isToday = true;
        }

        let date = new Date().toISOString();
        date = date.split("-")[2].split("T");
        date = date[1].split(".");
        const time = date[0];

        for(let i=0; i<rows.length ; i++) {
            if(isToday) {
                res[i] = {grade: parseInt(rows[i].value),
                    alignmentId: rows[i].alignmentId,
                    ratedUserId: rows[i].userId}
            } else {
                res[i] = {grade: parseInt(rows[i].value),
                    alignmentId: rows[i].alignmentId,
                    createdAt: `${year}-${month.monthNumber}-01 ${time}`,
                    ratedUserId: rows[i].userId}
            }
        }

        let data = {
            user: user.userId,
            company: auth.data.user.companyId,
            alignments: [...res]
        };

        try {
            let response = await sendMonthlyAlignment(data, auth);
            setFetchOpen(false);

            if (response.status === 201) {
                setPopUp({
                    popUp: true,
                    popUpTitle: "Sucesso",
                    popUpText: `Alinhamentos do IPA em ${month.name}/${year} ${fillOthers ? `de ${user ? user.name : ""}` : ""} enviados.`,
                    success: fillOthers ? 0 : 1,
                })

            } else {
                setPopUp({
                    popUp: true,
                    popUpTitle: "Erro",
                    popUpText: "Alinhamentos do IPA não puderam ser enviados.",
                    success: 1,
                })
            }

        } catch (error) {
            console.log(error);
        }

    };

    const defaultPropsMonths = {
        options: optionsMonths,
        defaultValue: optionsMonths[(today.getMonth())],
        getOptionLabel: (option) => {
            return option.name
        },
        getOptionSelected: (option) => {
            return option.name
        },
        onChange: (event, newValue) => {
            setFetchOpen(true);
            setMonth(newValue);
        },
    };

    const defaultPropsUsers = {
        options: optionsUsers,
        value: user,
        getOptionLabel: (option) => {
            return option.name
        },
        getOptionSelected: (option) => {
            return option.name
        },
        onChange: (event, newValue) => {
            setFetchOpen(true);
            setUser(newValue);
        },
    };

    const handleChangeSystem = () => {
        setFillOthers(!fillOthers);
    };

    return (
        <div>
            <Filters style={{justifyContent: fillOthers ? "space-between" : "flex-end"}}>
                {getSubmodulePermission(submodules.alignment, permissions.EMPLOYEES_VISUALIZATION_FILTER) && fillOthers ?
                    <Autocomplete
                        {...defaultPropsUsers}
                        id="users"
                        autoSelect
                        disableClearable
                        className={classes.userFormControl}
                        style={{width: 200}}
                        renderInput={(params) => <TextField {...params} label="Colaborador"
                                                            variant="outlined"/>}
                    />
                    : null}
                {getSubmodulePermission(submodules.alignment, permissions.DATA) && fillOthers ?
                    <Filters>
                        <Autocomplete
                            {...defaultPropsMonths}
                            id="months"
                            autoSelect
                            disableClearable
                            className={classes.formControl}
                            style={{width: 150}}
                            renderInput={(params) => <TextField {...params} label="Mês"
                                                                variant="outlined"/>}
                        />
                        <FormControl variant="outlined" className={classes.formControlYear}>
                            <InputLabel id="demo-simple-select-outlined-label">Ano</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={year}
                                onChange={e => {
                                    setYear(e.target.value)
                                    setFetchOpen(true);}}
                                label="Ano">
                                {optionsYear.map((year, index) => {
                                    return (
                                        <MenuItem key={index} value={year}>{year}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Filters>
                    : null}
                {getSubmodulePermission(submodules.alignment, permissions.EMPLOYEES_VISUALIZATION_FILTER) && getSubmodulePermission(submodules.alignment, permissions.DATA)  ?
                    <FormControlLabel
                        style={{marginTop: 10, display: 'flex', justifyContent: 'center'}}
                        control={<Switch checked={fillOthers === true} name="checkedA"/>}
                        label={"Preencher outros"}
                        onChange={handleChangeSystem}
                    />
                : null}
            </Filters>
            <TableToSendData handleSubmit={handleSubmit} handleChange={handleChange} textData={textData} getColor={getColor} year={year} value={month ? month.name : ""} rows={rows}/>
            {popUp.popUp ?
                <PopUp title={popUp.popUpTitle} string={popUp.popUpText} success={popUp.success} route={popUp.route ? popUp.route : null}/> : null}
            {fetchOpen ?
                <RenderPage open={fetchOpen}/> : null}
        </div>

    );
}
